var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRvn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D4FC5",
    d: "m11.535 16.98l-4.2 3.023l2.67-12.278zm.09-.022l2.55.03l-4.073-9.225zm2.798-.21l1.957-7.26l-.743-.9zm-.945-11.385l-3.226 2.175l4.71-1.523zm-.405 0l-2.003.075l-.3.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5D44",
    d: "m10.155 7.68l4.14 9.262l1.26-8.504zm.615-1.32l2.55-.998l-3.165 2.13zm.33-1.05l.645-.698l1.47.645zm.742-.78l1.013-.465l1.29 1.477zm1.08-.532h1.08l.6.652zm1.455 1.642l.255-.773l.263 1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E99749",
    d: "m10.335 7.597l5.16.705l-.51-2.175zm4.702-1.665l-.33-1.207l2.318.682zm-.48-1.132l-.285.773l-1.2-1.418z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvn);
export default __webpack_public_path__ + "static/media/rvn.29ce1a245b96baad72fb67fd73163f2d.svg";
export { ForwardRef as ReactComponent };